import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "@store/middleware";

import { getApplicationSpaBackendUrl } from "@utils";
import { type IBundleInfo, type IDocumentInfo } from "@types";
import { type TBundleProduct } from "@shared/types/product.types";
import { type TPurchaseType } from "@shared/types/purchase.types";

export const BUNDLE_INFO_API_REDUCER_KEY = "bundleInfoApi";
export const bundleInfoApi = createApi({
  reducerPath: BUNDLE_INFO_API_REDUCER_KEY,
  baseQuery: (arguments_, api, extraOptions) =>
    baseQueryWithAuth({ baseUrl: getApplicationSpaBackendUrl() })(arguments_, api, {
      ...extraOptions,
      isExternalService: true,
    }),
  endpoints: (builder) => ({
    postBundleInfo: builder.mutation<
      IBundleInfo,
      {
        type: TBundleProduct;
        purchaseType: TPurchaseType;
        documents: {
          externalId: IDocumentInfo["externalId"];
          externalDocumentIdentifier: IDocumentInfo["externalDocumentIdentifier"];
          type: IDocumentInfo["type"];
          purchaseType: IDocumentInfo["purchaseType"];
          documentCreatedIn: IDocumentInfo["documentCreatedIn"];
          completed: boolean;
        }[];
      }
    >({
      query: (body) => ({
        url: "/bundle-info",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { usePostBundleInfoMutation } = bundleInfoApi;
